<template>
  <div class="followlinks">
    follow me <hr>
    <a href="https://twitter.com/Piratkopia13" target="_blank"><img src="../assets/twitter-logo.svg"></a>
    <a href="https://www.linkedin.com/in/alexander-wester-0619b1114/" target="_blank"><img src="../assets/linkedin-logo.svg"></a>
    <a href="https://www.instagram.com/piratkopia13/" target="_blank"><img src="../assets/instagram-logo.svg"></a>
    <a href="https://github.com/Piratkopia13/" target="_blank"><img src="../assets/github-logo.svg"></a>
  </div>
</template>

<script>
export default {
  name: 'FollowLinks'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr {
  width: 80px;
  display: inline-block;
  margin: 5px 20px;
}
a {
  margin: 15px;
  position: relative;
  top: 4px;
}
img {
  width: 20px;
}
a:hover {
  filter: invert(0.5) sepia(1) saturate(2) hue-rotate(150deg);
}
</style>
